
    export default 
    {
    "select_platform": {
        "title": "A quale piattaforma vuoi accedere?"
    }
}